import React from 'react';
import classnames from 'classnames';
import { Route } from 'types';
import { RouteComponentProps } from 'react-router';
import { SIGNUP, LOGIN, PASSWORD_RESET, PASSWORD_CHANGE, CONFIRMATION_EXPIRED,
  CONFIRMATION_VERIFIED, LANDING, SIGNUP_SUCCESS } from 'constants/routes';
import Logo from 'components/Logo';
import Button from 'components/Button';
import Text from 'components/Text';
import { t } from 'components/Translate';

import styles from './Onboarding.module.scss';

type Props = {
  route: Route,
} & Pick<RouteComponentProps, 'history'>;

const Header: React.FC<Props> = ({ route, history }: FunctionProps<Props>) => {
  let right: { text: string, action: string, onClick: () => void } | null = null;
  if ([SIGNUP, SIGNUP_SUCCESS, CONFIRMATION_EXPIRED, CONFIRMATION_VERIFIED].includes(route)) {
    right = {
      text: 'onboarding.header.alreadyHave',
      action: 'common.action.login',
      onClick: () => history.push(LOGIN),
    };
  } else if (route === LOGIN) {
    right = {
      text: 'onboarding.header.dontHave',
      action: 'common.action.signup',
      onClick: () => history.push(SIGNUP),
    };
  } else if (route === PASSWORD_RESET || route === PASSWORD_CHANGE) {
    right = {
      text: 'onboarding.header.rememberPassword',
      action: 'common.action.login',
      onClick: () => history.push(LOGIN),
    };
  }

  return (
    <div className={ styles.header }>
      <div
        className={ classnames('cursor--pointer', { [styles.headerMargin]: !right }) }
        onClick={ () => history.push(LANDING) }
      >
        <Logo className={ styles.logo } />
      </div>

      { right &&
        <div className={ styles.right }>
          <Text className="d-none d-sm-inline-flex mr-3" color="dark-light">
            { t(right.text) }
          </Text>
          <Button theme="ghost" size="small" onClick={ right.onClick }>
            { t(right.action) }
          </Button>
        </div>
      }
    </div>
  );
};

export default Header;
